module.exports = __webpack_public_path__ + "img/-LV4zeXMLS7egQEHAIH4.9f0d5d7c.jpg";